import React from 'react';
import { Product, SalesPackage } from '../../types';
import styled from 'styled-components';
import { colors } from '@telia/styleguide';
import { MediaQueries } from '../../util/MediaQueries';

interface SummaryWidgetProps {
  selectedBundle: SalesPackage;
  selectedAdditionalProducts: Product[];
  hideOffer?: boolean;
}

const SummaryWidget: React.FC<SummaryWidgetProps> = ({
  selectedBundle,
  selectedAdditionalProducts,
  hideOffer = false
}) => {
  const sumAdjustedEstablishment = selectedAdditionalProducts.reduce(
    (sum, currentProduct) => sum + currentProduct.adjustedEstablishmentFee,
    selectedBundle.adjustedEstablishmentFee
  );
  const sumAdjustedRecurringPrice = selectedAdditionalProducts.reduce(
    (sum, currentProduct) => sum + currentProduct.adjustedRecurringCharge,
    selectedBundle.adjustedRecurringCharge
  );

  const sumRecurringCharge = selectedAdditionalProducts.reduce(
    (sum, currentProduct) => sum + currentProduct.recurringCharge,
    selectedBundle.recurringCharge
  );

  const hasOffer = sumRecurringCharge > sumAdjustedRecurringPrice;

  return (
    <Container>
      <p>
        <strong>Oppsummering</strong>
      </p>
      <table style={{ borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <TableHeading style={{ float: 'left' }}>Produkt</TableHeading>
            <TableHeading>Etablering</TableHeading>
            <TableHeading>Månedspris</TableHeading>
          </tr>
        </thead>
        <tbody>
          {selectedBundle.products.map((prod, index) => {
            return (
              <tr key={index}>
                <TableEntity>{prod.name}</TableEntity>
                <TableEntity>{Math.floor(prod.adjustedEstablishmentFee)},-</TableEntity>
                <TableEntity>{Math.floor(prod.adjustedRecurringCharge)},-</TableEntity>
              </tr>
            );
          })}
          {selectedAdditionalProducts.map((prod, index) => {
            return (
              <tr key={index}>
                <TableEntity>{prod.name}</TableEntity>
                <TableEntity>{prod.adjustedEstablishmentFee},-</TableEntity>
                <TableEntity>{prod.adjustedRecurringCharge},-</TableEntity>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr style={{ color: colors.green600, borderTop: '1px solid black' }}>
            <TableHeading style={{ textAlign: 'left' }}>Totalt</TableHeading>
            <TableHeading style={{ textAlign: 'left' }}>{sumAdjustedEstablishment},-</TableHeading>
            <TableHeading style={{ textAlign: 'left' }}>{sumAdjustedRecurringPrice},-</TableHeading>
          </tr>
        </tfoot>
      </table>
      {!hideOffer && hasOffer && <PriceAfterCampaign>{sumRecurringCharge},-/md. etter 12 md.</PriceAfterCampaign>}
    </Container>
  );
};

export default SummaryWidget;

const Container = styled.div`
  padding: 1rem;
  ${MediaQueries.onlyMobile} {
    padding: 0.5rem;
  }
  background: ${colors.lightGrey};
  border-radius: 5px;
`;

const TableHeading = styled.th`
  font-size: 1rem;
  padding: 0.5rem;
  ${MediaQueries.onlyMobile} {
    font-size: 0.9rem;
  }
`;

const TableEntity = styled.td`
  font-size: 1rem;
  padding: 0.5rem;
  ${MediaQueries.onlyMobile} {
    font-size: 0.9rem;
  }
`;

const PriceAfterCampaign = styled.p`
  font-size: 1rem;
  margin: 1rem 0 0 0.5rem;
  ${MediaQueries.onlyMobile} {
    font-size: 0.9rem;
  }
`;
